<template>
  <div class="catalog">
    <h2>Catalog</h2>
    <div>{{ connmsg }}</div><br>
    <div class="mui-container-fluid">
      <div class="mui-row">
        <div class="mui-select mui-col-md-4">
          <select v-model="filterSystem">
            <option>All</option>
            <option>Astra Tech Osseospeed EV 4.2</option>
            <option>Astra Tech Osseospeed 3.5/4.0</option>
            <option>Astra Tech Osseospeed 4.5/5.0</option>
            <option>Conelog 3.8</option>
            <option>Megagen Anyridge 3.5/8.4</option>
            <option>Nobel Biocare Active NP 3.5</option>
            <option>Osstem TS Mini 3.5</option>
            <option>Straumann NC 3.3</option>
            <option>Straumann RC 4.1/4.8</option>
            <option>Zimmer TPS/MiS Seven/BHI/Alpha-Bio 3.5</option>
            <option>Screw</option>
            <option>Tool</option>
            <option>Zirconia Preparation Set</option> 
          </select>
          <label>System</label>
        </div>
        <div class="mui-select mui-col-md-4">
          <select v-model="filterType">
            <option>All</option>
            <option v-for="yy in listyy" :key="yy">{{ yy }}</option>
          </select>
          <label>Type</label>
        </div>
        <div class="mui-select mui-col-md-4">
          <select v-model="filterSpec">
            <option>All</option>
            <option v-for="zz in listzz" :key="zz">{{ zz }}</option>
          </select>
          <label>Spec</label>
        </div>
      </div>
    </div>
    <table class="mui-table mui-table--bordered">
      <thead>
        <tr>
          <th>SKU A4L</th>
          <th>SKU C+M</th>
          <th>System</th>
          <th>Type</th>
          <th>Spec</th>
          <th></th>
          <th>QTY</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="product in filteredItems" :key="product.sku_a4l">
          <td>{{ product.sku_a4l }}</td>
          <td>{{ product.sku_cm }}</td>
          <td>{{ product.xx }}</td>
          <td>{{ product.yy }}</td>
          <td>{{ product.zz }}</td>
          <td>{{ product.ab }}</td>
          <td>{{ product.qty }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import router from '@/router'
import store from '@/store'

export default {
  name: 'catalog',
  data() {
    return {
      filterSystem: 'All',
      filterType: 'All',
      filterSpec: 'All',
      products: [],
      listyy: [
        'C-Base',
        'Diameter 1.6 mm',
        'Diameter 1.8 mm',
        'Diameter 2.0 mm',
        'Gingiva Former Pekkton',
        'LTS-Base',
        'LTS-Hybrid Abutment Zirconium',
        'Preform Titanium',
        'Scanbody',
        'Screw Driver',
        'T-Base',
        'N/A'
      ],
      listzz: [
        'Angulated',
        'Anterior Small',
        'Anterior Large',
        'ISO-Shaft',
        'Length 6.1 mm',
        'Length 7.1 mm',
        'Length 7.9 mm',
        'Length 8.0 mm',
        'Length 8.6 mm',
        'Length 8.3 mm',
        'Length 6.7 mm',
        'Length 6.8 mm',
        'Length 7.8 mm',
        'Manual',
        'Molar',
        'Molar Inverse',
        'Premolar',
        'Premolar Straight',            
        'Small Platform',
        'Straight',
        'Wide Platform',
        'N/A'
      ],
      connmsg: '',
      sortAsc: true
    }
  },
  beforeCreate() {
    if (!store.state.isLogged) {
      router.push('/')
    }
  },
  created() {
    this.getProducts()
  },
  methods: {
    getProducts() {
      this.axios.get('getcatalog').then(
        response => {
          this.products = response.data
        },
        () => {
          this.connmsg = 'Error: Could not reach server!'
        }
      )
    }
  },
  computed: {
    filteredItems() {
      var self = this
      let result = self.products
      if (self.filterSystem != 'All') {
        result = result.filter(function(product) {
          return product.xx.includes(self.filterSystem)
        })
      }
      if (self.filterType != 'All') {
        result = result.filter(function(product) {
          return product.yy.includes(self.filterType)
        })
      }
      if (self.filterSpec != 'All') {
        if (self.filterSpec === 'Molar' || self.filterSpec === 'Premolar' || self.filterSpec === 'Straight') {
          result = result.filter(function(product) {
            if (product.zz.includes(self.filterSpec) && product.zz.length < 9) {
              return true
            }
            else {
              return false
            }
          })
        }
        else {
          result = result.filter(function(product) {
            return product.zz.includes(self.filterSpec)
          })
        }
      }
      // Sort the remaining values
      let ascDesc = this.sortAsc ? 1 : -1
      return result.sort((a, b) => ascDesc * a.sku_a4l.localeCompare(b.sku_a4l))
    },
    filteredYY() {
      var self = this
      let result = self.listyy
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Catalog.vue?91a244e2